"use client";

import React, { useEffect, useState } from "react";
import Hero from "./components/hero/Hero";
import FeaturedSlider from "./components/home/FeaturedSlider";
import { usePathname } from "next/navigation";
import TopNavbar from "./components/navbar/TopNavbar";
import SideBox from "./components/tasks/Sidebox";
import Footer from "./components/footer/Footer";
import ProtectedRoute from "./components/protected/ProtectedRoute";
import { SocketProvider } from "./context/SocketProvider";
import axiosAuth from "./utils/axiosAuth";
import FeautureInfo from "./components/feature/FeautureInfo";
import FeatureSection from "./components/feature/FeautureSection";
import { useNotification } from "./context/NotificationContext";
import TestimonialsSection from './components/TestimonialsSection';
const noNavbarRoutes = ["/login", "/signup"];

export default function HomePage() {
  const pathname = usePathname();
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  


  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axiosAuth.get(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/auth/me`);
        setCurrentUser(res.data);
      } catch (err) {
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

 // In your HomePage component
useEffect(() => {
  if (!sessionStorage.getItem("safetyTipShown")) {
    showNotification(
      "For your safety, don’t save taskers’ numbers after a job.",
      "safety"
    );
    showNotification(
      "Reload the app regularly for the latest updates and best experience.",
      "info"
    );
    showNotification(
      "Never share your payment details with anyone.",
      "warning"
    );
    sessionStorage.setItem("safetyTipShown", "true");
  }
}, [showNotification]);
  if (loading) return <div className="flex justify-center items-center min-h-screen">Loading...</div>;


  return (
    <ProtectedRoute>
      <SocketProvider currentUser={currentUser}>  
        <div className="bg-gray-50 min-h-screen flex flex-col">
          {/* Navbar */}
          {!noNavbarRoutes.includes(pathname) && <TopNavbar />}
          
          {/* Hero Section - Centered */}
          <div className="flex-grow flex flex-col justify-center items-center pt-12 px-4">
            <div className="w-full max-w-7xl mx-auto">
              <Hero />
            </div>
          </div>

          {/* Main Content - Centered */}
          <main className="flex-grow">
            <div className="max-w-7xl mx-auto px-4 py-8">
              <SideBox />
              <FeaturedSlider onJobClick={(job) => { /* handle job click here */ }} />
              <FeatureSection/>
              
              <div className="flex justify-center mt-8">
                <div className="w-full max-w-4xl">
                  <FeautureInfo />
                  {/* Add testimonials section */}
                  <TestimonialsSection />
                </div>
              </div>
            </div>
          </main>

          {/* Footer */}
          <Footer />
        </div>
      </SocketProvider>
    </ProtectedRoute>
  );
}
